import Divider from 'semantic-ui-react/dist/commonjs/elements/Divider';
import '@purple/semantic-ui-purple-theme/components/divider.css';

export default Divider;
